module.exports = {
  // eslint-disable-next-line no-loss-of-precision
  whiteListMintCount: 1,
  totalGas: 300000,
  MaxMintCounts: 500,
  MINTCONTRACT_ADDRESS: '0xa9cE8a56e9cF930545ED87bd28A7c0d701493E49',
  BUNNYTOKEN_ADDRESS: '0x1aa5282692398c078e71Fb3e4A85660d1BF8F586',
  BurnBunny: 2222,
}
